import { ModalProvider } from '../context/ModalContext';

export const withModalProvider = (component: () => React.ReactNode) => () =>
  <ModalProvider>{component()}</ModalProvider>;
